/** Trioga's compact vector wordmark, based on the supplied Software Studio logo. */
export function TriogaLogo({ className = '', variant = 'light' }) {
  const dark = variant === 'dark';
  return (
    <svg
      className={className}
      viewBox="0 0 390 105"
      role="img"
      aria-label="Trioga Software Studio"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8">
        <path d="M28 43 50 5l22 38" stroke="#a56bea" />
        <path d="m26 53-21 37a5 5 0 0 0 4 8h39" stroke="#1ccbd6" />
        <path d="m74 53 21 37a5 5 0 0 1-4 8H52" stroke="#4779e8" />
      </g>
      <circle cx="50" cy="66" r="5.8" fill={dark ? '#f7f8fc' : '#15202b'} />
      <text
        x="128"
        y="51"
        fill={dark ? '#f7f8fc' : '#15202b'}
        fontFamily="Avenir Next, Montserrat, Century Gothic, Arial, sans-serif"
        fontSize="43"
        fontWeight="500"
        letterSpacing="5.2"
      >
        TRIOGA
      </text>
      <text
        x="130"
        y="80"
        fill={dark ? '#9ba4b3' : '#687383'}
        fontFamily="Avenir Next, Montserrat, Century Gothic, Arial, sans-serif"
        fontSize="12"
        fontWeight="400"
        letterSpacing="7.5"
      >
        SOFTWARE STUDIO
      </text>
    </svg>
  );
}
